import {useContext} from 'react'
import {AuthenticatedUserContext} from "../context/AuthenticatedUserContextProvider";

export function useAuthenticatedUserContext()
{
    const context = useContext(AuthenticatedUserContext);

    if (!context) {
        throw new Error(
            "useAuthenticatedUserContext must be used within the scope of AuthenticatedUserContextProvider"
        );
    }

    return context;
}